'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _noncompliantMembers = require('./noncompliant-members.component');

var _noncompliantMembers2 = _interopRequireDefault(_noncompliantMembers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.member-compliance.noncompliant-members', []).component('noncompliantMembers', _noncompliantMembers2.default).name;


// WEBPACK FOOTER //
// ./components/app/admin/member-compliance/noncompliant-members/noncompliant-members.module.js